/**
 * MouseAdapter - Handles mouse drag events for the GestureController
 * Tracks mouse down/move/up for drag gestures
 */
export class MouseAdapter {
  constructor(controller) {
    this.controller = controller;
    this.element = controller.element;
    this.isDragging = false;

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);

    this.element.addEventListener('mousedown', this.handleMouseDown);
    // Mouse move/up are on document to capture outside element
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  }

  handleMouseDown(e) {
    // Ignore if not left click
    if (e.button !== 0) return;

    this.isDragging = true;
    this.controller.handleStart(e.clientX, e.clientY, e);
  }

  handleMouseMove(e) {
    if (!this.isDragging || !this.controller.active) return;
    this.controller.handleMove(e.clientX, e.clientY, e);
  }

  handleMouseUp(e) {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.controller.handleEnd(e);
  }

  destroy() {
    this.element.removeEventListener('mousedown', this.handleMouseDown);
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }
}
